import { useTranslation } from 'react-i18next'

import { EID } from '@/lib/element-ids.registry'

export type ReportViewMode = 'compact' | 'full'

interface ReportViewToggleProps {
  value: ReportViewMode
  onChange: (mode: ReportViewMode) => void
}

const OPTIONS: { mode: ReportViewMode; eid: string; labelKey: string }[] = [
  { mode: 'compact', eid: EID['listing-builder-report-view-compact'], labelKey: 'listingBuilder.report.view.compact' },
  { mode: 'full', eid: EID['listing-builder-report-view-full'], labelKey: 'listingBuilder.report.view.full' },
]

/** Segment control toggling the report between compact and full views. */
export function ReportViewToggle({ value, onChange }: ReportViewToggleProps) {
  const { t } = useTranslation()
  return (
    <div
      id={EID['listing-builder-report-view-toggle']}
      role="group"
      aria-label={t('listingBuilder.report.view.label')}
      className="inline-flex gap-1 rounded-lg border border-neutral-200 dark:border-neutral-800 p-0.5"
    >
      {OPTIONS.map(({ mode, eid, labelKey }) => (
        <button
          key={mode}
          id={eid}
          type="button"
          aria-pressed={value === mode}
          onClick={() => onChange(mode)}
          className={`px-3 py-1 text-xs rounded ${
            value === mode
              ? 'bg-primary-500 text-white'
              : 'text-neutral-600 dark:text-neutral-400'
          }`}
        >
          {t(labelKey)}
        </button>
      ))}
    </div>
  )
}
